interface ViewOffSlashIconProps {
  color?: string;
  className?: string;
  onClick?: () => void;
  size?: number;
}
function ViewOffSlashIcon({
  color,
  className,
  onClick,
  size,
}: ViewOffSlashIconProps) {
  return (
    <svg
      width={size || 40}
      height={size || 40}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M46.3658 36.6149C48.3999 34.5827 49.9705 32.563 50.9968 31.1146C51.6656 30.1707 52 29.6986 52 29C52 28.3014 51.6656 27.8293 50.9968 26.8854C47.9914 22.6438 40.3162 13.5 30 13.5C28.0028 13.5 26.1047 13.8427 24.3202 14.4262M18.4443 17.3693C14.0086 20.3802 10.7327 24.4445 9.00329 26.8854C8.33442 27.8293 8 28.3014 8 29C8 29.6986 8.33442 30.1707 9.00329 31.1146C12.0086 35.3563 19.6837 44.5 30 44.5C34.3798 44.5 38.2832 42.8519 41.5557 40.6308"
        stroke={color || 'var(--black)'}
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.8873 24.5C23.7212 25.666 23 27.2771 23 29.0564C23 32.6151 25.8849 35.5 29.4436 35.5C31.2229 35.5 32.834 34.7788 34 33.6126"
        stroke={color || 'var(--black)'}
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
      />
      <path
        d="M11 8.5L50 48.5"
        stroke={color || 'var(--black)'}
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ViewOffSlashIcon;
